export default function Tag(props) {
    return <div className={`Tag ${props.className ? props.className : ""}`}>{props.name}</div>;
}
